<script lang="ts">
	import { RadioButtonGroup } from '@isoftdata/svelte-checkbox'
	import { booleanToString } from '@isoftdata/utility-boolean'
	import { stringToBoolean } from '@isoftdata/utility-string'

	import type { ComponentProps, Snippet } from 'svelte'

	interface Props
		extends Omit<
			ComponentProps<typeof RadioButtonGroup>,
			'allowUnset' | 'btnGroupClass' | 'labelParentClass' | 'options' | 'value'
		> {
		id?: string
		label?: string
		hint?: Snippet | string
		value?: boolean | null
		disabled?: boolean
	}

	let {
		//,
		value = $bindable(null),
		...rest
	}: Props = $props()
</script>

<RadioButtonGroup
	{...rest}
	allowUnset
	labelParentClass="mb-0"
	btnGroupClass="mb-1 w-100"
	options={[
		{ label: 'Yes', value: 'True' },
		{ label: 'No', value: 'False' },
	]}
	bind:value={() => (value === null ? '' : booleanToString(value)), v => (value = v === '' ? null : stringToBoolean(v))}
></RadioButtonGroup>
